import { BALANCE } from '../config/balance';
import { clamp } from '../core/vec';

/**
 * 跟随相机 + trauma 屏震。
 * trauma 由伤害事件累加，偏移 = trauma² × maxOffset × 确定性正弦噪声。
 */
export class Camera {
  x = 0;
  y = 0;
  shakeX = 0;
  shakeY = 0;
  private trauma = 0;
  /** 全屏闪光 0..1 与颜色（受击红 / 升级金 / 进化橙）。 */
  flash = 0;
  flashColor = '#C7483B';

  follow(
    px: number,
    py: number,
    viewW: number,
    viewH: number,
    dt: number,
    now: number,
  ): void {
    this.x = px - viewW / 2;
    this.y = py - viewH / 2;

    if (this.trauma > 0) {
      this.trauma = Math.max(0, this.trauma - BALANCE.juice.shakeDecay * dt);
    }
    if (this.flash > 0) {
      this.flash = Math.max(0, this.flash - BALANCE.juice.flashDecay * dt);
    }
    const mag = this.trauma * this.trauma * BALANCE.juice.shakeOffsetPx;
    const t = now / 1000;
    this.shakeX = mag * (Math.sin(t * 91) * 0.6 + Math.sin(t * 47) * 0.4);
    this.shakeY = mag * (Math.cos(t * 83) * 0.6 + Math.sin(t * 59) * 0.4);
  }

  addTrauma(amount: number): void {
    this.trauma = clamp(
      this.trauma + amount * BALANCE.juice.shakePerDamage,
      0,
      BALANCE.juice.shakeMax,
    );
  }

  addFlash(color: string, intensity: number): void {
    this.flashColor = color;
    this.flash = clamp(Math.max(this.flash, intensity), 0, 1);
  }

  get offsetX(): number {
    return this.shakeX;
  }

  get offsetY(): number {
    return this.shakeY;
  }
}
